import React from 'react';
import Button from '../../../../../components/ComponentsV1/Button';
import DynamicField from './DynamicField';
import {
  BUTTON_TYPE,
  CONFIRM_BUTTON_LABEL,
  SUBMIT_BUTTON_LABEL,
  CANCEL_BUTTON_LABEL,
} from '../constants';

const ActionForm = ({
  confirmMessage,
  submitLabel,
  fields = [],
  fieldValues = {},
  fieldValuesVersion = 0,
  onFieldChange,
  onSubmit,
  isSubmitting = false,
  showConfirm = false,
  onConfirm,
  onCancelConfirm,
}) => {
  if (!fields.length) return null;

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-5 tw-bg-white tw-p-8 tw-rounded-2xl'>
      <div className='tw-w-full tw-flex tw-flex-wrap tw-gap-0'>
        {fields.map((field) => (
          <DynamicField
            key={`${field.name}-${fieldValuesVersion}`}
            field={field}
            value={fieldValues[field.name]}
            onChange={(value) => onFieldChange?.(field.name, value)}
          />
        ))}
      </div>

      {showConfirm && confirmMessage ? (
        <div className='tw-border tw-border-solid tw-border-red-200 tw-bg-red-50 tw-rounded-lg tw-p-6 tw-flex tw-flex-col tw-gap-4'>
          <div className='tw-text-[1.4rem] tw-font-medium tw-text-zinc-800'>
            {confirmMessage}
          </div>
          <div className='tw-flex tw-gap-4'>
            <Button
              title={CANCEL_BUTTON_LABEL}
              type={BUTTON_TYPE.OUTLINE}
              onClick={onCancelConfirm}
            />
            <Button
              title={submitLabel || CONFIRM_BUTTON_LABEL}
              type={BUTTON_TYPE.PRIMARY}
              loading={isSubmitting}
              onClick={onConfirm}
            />
          </div>
        </div>
      ) : (
        <div>
          <Button
            title={submitLabel || SUBMIT_BUTTON_LABEL}
            type={BUTTON_TYPE.PRIMARY}
            size='medium'
            className='tw-h-14 tw-w-fit tw-px-2'
            loading={isSubmitting}
            onClick={onSubmit}
          />
        </div>
      )}
    </div>
  );
};

export default ActionForm;
